// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"814a5912","774":"c7ee5f1c","858":"b2034faa"}[chunkId] + ".chunk.js";
};